<template>
  <div class="ques">
    <div class="mask"></div>
    <img v-show="bgflag" src="../assets/images/insects/question_bg.png">
    <div class='mackContend'>
        <div class='mackClose'  @click="closeQues"><img src="../assets/images/insects/btn_close.png"></div>
        <div class='quesContend'>
        <!-- <h3>窗户破了，在玻璃碎片上检测出了 鳞片残留，会是哪种昆虫的呢？</h3> -->
        <h3>{{quesItem.title}}</h3>
        <div class="quesList">
            <div class="box">
            <div class="column">
                <span class="item " @click="chooseA" v-bind:class="{ bgActive: isActive=='a' }">
                <img src="../assets/images/insects/a.png"/>
                </span>
                <span class="item" @click="chooseB" v-bind:class="{ bgActive: isActive=='b' }">
                <img src="../assets/images/insects/b.png"/>
                </span>
            </div>
            <div class="column">
                <span class="item"  @click="chooseC" v-bind:class="{ bgActive: isActive=='c' }">
                <img src="../assets/images/insects/c.png"/>
                </span>
                <span class="item"  @click="chooseD" v-bind:class="{ bgActive: isActive=='d' }">
                <img src="../assets/images/insects/d.png"/>
                </span>
            </div>
            </div>      
        </div>
        <div class="submit" @click="submit"> <img src="../assets/images/insects/btn_submit.png"></div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props:{
      quesItem:{
          type:Object,
          default:function(){
              return {}
          }
      }
  },
  data(){
      return{
          bgflag:false,
          isActive:'0',
          timer3:null
      }
  },
   created () {
      const that = this
      that.timer3 = setInterval(function () {
          console.log(document.readyState)
          if (document.readyState === 'complete') {
              that.$emit('quesReady',true);
              window.clearInterval(that.timer3)
          }
      }, 1000)
  },
  methods:{
      chooseA(){
          this.isActive='a'
      },
      chooseB(){
          this.isActive='b'
      },
      chooseC(){
          this.isActive='c'
      },
      chooseD(){
          this.isActive='d'
      },
      closeQues(){
        this.isActive='0';
          this.$emit('close',true)
      },
      submit(){
          if(this.isActive==this.quesItem.result){
            if(this.quesItem.id==1){
                this.$emit('correct',1);
                this.closeQues()
            }
            if(this.quesItem.id==2){
                this.$emit('correct',2);
                this.closeQues()
            }
            if(this.quesItem.id==3){
                this.$emit('correct',3);
                this.closeQues()
            }
            if(this.quesItem.id==4){
                this.$emit('correct',4);
                this.closeQues()
            }
          }else{
              this.$emit('errorAnswer',true);
              this.closeQues()
          }
      }
  }
}
</script>

<style scoped>
.mask{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.7;
  z-index: 6;
}
.mackContend{
  position: fixed;
  left: 50%;
  top: 50%;
  width: 664px;
  height: 643px;
  margin: -321px 0 0 -332px;
  z-index: 7;
  background: url('../assets/images/insects/question_bg.png');
  background-size: contain;
}
.mackContend .mackClose{
  width: 64px;
  height: 64px;
  position: absolute;
  right: -20px;
  top:-20px;
}
.mackContend .mackClose img{
  width: 100%;
  height: 100%;
}
.mackContend .quesContend{
  margin: 40px;
}
.mackContend .quesContend h3{
  font-size: 36px;
  color: #A06C46;
  text-align: center;
}
.mackContend .quesContend .submit{
  margin-top: 10px;
  text-align: center;
}
.mackContend .quesContend .submit img{
  width: 311px;
  height: 97px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.column {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
}
.column .item{
  width: 192px;
  height: 163px;
}
.bgActive{
  background: #ffffff;
  border-radius: 40px;
}
.column .item{
    margin:5px 10px;
}
.column .item img{
    width: 100%;
  height: 100%;
}
</style>
